import React from "react";
import { Routes, Route } from "react-router-dom";
import NoMatch from "./NoMatch";
import "./Tools.css";
import StyleTools from "./StyleTools/";
import ColorTools from "./ColorTools/";
import TypeTools from "./TypeTools/";
import GraphicsTools from "./GraphicsTools/";
import PhotosTools from "./PhotosTools/";
import AlignTools from "./AlignTools/";
import ProductInfo from "./ProductInfo/";
import UploadTools from "./UploadTools/";
import AdminTools from "./AdminTools/";

class Tools extends React.Component {
  render() {
    return (
      <div className="tools__content">
        <Routes>
          <Route path="style" element={<StyleTools />} />
          <Route path="color" element={<ColorTools />} />
          <Route path="text" element={<TypeTools />} />
          <Route path="graphics" element={<GraphicsTools />} />
          <Route path="photos" element={<PhotosTools />} />
          <Route path="align" element={<AlignTools />} />
          <Route path="info" element={<ProductInfo />} />
          <Route path="upload" element={<UploadTools />} />
          <Route path="admin" element={<AdminTools />} />
          <Route
            component={NoMatch}
            routeId={this.props.routeId}
            location={this.props.location}
          />
        </Routes>
      </div>
    );
  }
}

export default Tools;
